import * as React from 'react';
import { RenderElementProps } from 'slate-react';

import { MediaProps, MediaType } from '../media-constant';
import { dynamicEditorComponent } from '@doltech/utils/lib/dynamicWithProps/dynamicEditorComponent';
import { withDynamicBlogEditorPluginHydration } from '@doltech/core/lib/hooks/withDolHydrationOnDemand';

const UploadVocabList = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() => import(/* webpackExports: "UploadVocabList" */'./UploadVocabList').then((mod) => mod.UploadVocabList))
);
const UploadVocabListViewEditable = withDynamicBlogEditorPluginHydration({ canInteract: true })(
  dynamicEditorComponent(() =>
    import(/* webpackExports: "UploadVocabListViewEditable" */'./UploadVocabListView').then((mod) => mod.UploadVocabListViewEditable)
  )
);

export const renderVocabList = (opt: MediaProps) => (props: RenderElementProps) => {
  const { element } = props;
  if (element.type === MediaType.VOCAB_LIST) {
    return (
      <div id={element.id as string} contentEditable={false}>
        <UploadVocabList element={element} id={element.id as string} {...props} {...opt} />
      </div>
    );
  }
  if (element.type === MediaType.VOCAB_LIST_PRE) {
    return (
      <div id={element.id as string} contentEditable={false}>
        <UploadVocabListViewEditable
          element={element}
          url={element.urlVocab}
          id={element.id as string}
          {...props}
          {...opt}
        />
      </div>
    );
  }
  return null;
};
